export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";